module.exports = __webpack_public_path__ + "img/DE01618.7a26fd49.png";